import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { StudyReportWizardFactory } from "src/app/factory/study-report-wizard.factory";
import {
  SearchFilter,
  IFilterResponse,
} from "src/app/infrastructure/iFilter-component";
import { StudyReportSearchItem } from "src/app/model/study-report-search-item";
import { MenuService } from "src/app/services/menu.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { PdfService } from "src/app/services/pdf.service";
import { StudyReportService } from "src/app/services/study-report/study-report.service";
import { StudyReportWizardService } from "src/app/services/wizard/study-report/study-report.wizard.service";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import {
  StudyReportViewerDialogRequest,
  StudyReportViewerDialogComponent,
  StudyReportViewerDialogResponse,
} from "../../dialogs/study-report-viewer/study-report-viewer-dialog.component";
import { SearchFilterComponent } from "../../search-filter/search-filter.component";
import { SelectionModel } from "@angular/cdk/collections";
import { LogViewDialogComponent } from "../../dialogs/log-view/log-view-dialog.component";
import { Base64ToBlobService } from "../../../services/base64-to-blob.service";
import { ReportPhysicianReplacementDialogComponent } from "../../dialogs/report-physician-replacement-dialog/report-physician-replacement-dialog.component";
import { AuthService } from "../../../services/auth.service";
import { StudyReportLogisticsCommentDialogComponent } from "../../dialogs/study-report-logistics-comment-dialog/study-report-logistics-comment-dialog.component";
import { StatusPhotographyDialogComponent } from "../../dialogs/status-photography-dialog/status-photography-dialog.compnent";
import { AdmissionService } from "../../../services/admission.service";
import { StudyReportReverserReasonDialogComponent } from "../../dialogs/study-report-reverser-reason/study-report-reverser-reason-dialog.component";
import { StudyReportStateEnum } from "src/app/model/study-report-state";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { StudyReportUnificationDialogService } from "src/app/services/study-report/study-report-unification-dialog.service";
import { MedicalOrderScannViewComponent } from "../../dialogs/medical-order-scann-view/medical-order-scann-view-dialog.component";
import { StudyReportDeliverySectorDialogComponent } from "../../dialogs/study-report-delivery-sector-dialog/study-report-delivery-sector-dialog.component";

interface ColumnDefinition {
  field: string;
  title: string;
  visible: boolean;
  order: number;
  width: number;
}

@Component({
  selector: "app-study-report-control-search",
  templateUrl: "./study-report-control-search.component.html",
  styleUrls: ["./study-report-control-search.component.css"],
  providers: [DatePipe],
})
export class StudyReportControlSearchComponent implements OnInit, OnDestroy {
  canPublishForced: boolean;
  loading: boolean;
  loadingAction: boolean;
  loadingMasiveAction: boolean;
  studyReportSearchItem: StudyReportSearchItem[] = [];
  allItems: StudyReportSearchItem[] = [];
  searchFilters: SearchFilter[];

  dataSource: StudyReportSearchItem[] = [];
  selection = new SelectionModel<StudyReportSearchItem>(true, []);
  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  columnFilters: { [field: string]: string } = {};

  private sessionColumnsKey = "study-report-control-search.columns.v1";
  private sessionSortKey = "study-report-control-search.sort.v1";
  private sessionColumnWidthsKey = "study-report-control-search.column-widths.v1";

  private sortField: string = null;
  private sortDirection: "asc" | "desc" = "asc";
  private dragSourceField: string = null;
  private resizeListeners: { move: EventListener; up: EventListener } = null;

  columnsDefinition: ColumnDefinition[] = [
    { field: "reservationHour",          title: "Fecha turno",       visible: true,  order: 0,  width: 120 },
    { field: "deliveryHour",             title: "Fecha entrega",     visible: true,  order: 1,  width: 120 },
    { field: "protocol",                 title: "Protocolo",         visible: true,  order: 2,  width: 75  },
    { field: "patientFullName",          title: "Paciente",          visible: true,  order: 3,  width: 125 },
    { field: "practiceName",             title: "Práctica",          visible: true,  order: 4,  width: 125 },
    { field: "serviceName",              title: "Servicio",          visible: true,  order: 5,  width: 80  },
    { field: "entityName",               title: "Entidad",           visible: true,  order: 6,  width: 110 },
    { field: "state",                    title: "Estado",            visible: true,  order: 7,  width: 80  },
    { field: "studyReportRegion",        title: "Subesp.",           visible: true,  order: 8,  width: 65  },
    { field: "cantidad",                 title: "Cantidad",          visible: true,  order: 9,  width: 55  },
    { field: "adminControled",           title: "Ctrl. admin.",      visible: true,  order: 10, width: 70  },
    { field: "studyReportPhysician",     title: "Informante",        visible: true,  order: 11, width: 105 },
    { field: "statusPhotographyName",    title: "Estado foto.",      visible: true,  order: 12, width: 90  },
    { field: "published",                title: "Informe public.",   visible: true,  order: 13, width: 85  },
    { field: "lastLogisticscommentary",  title: "Comentarios log.",  visible: true,  order: 14, width: 105 },
    { field: "visualizationCode",        title: "Copiar link",       visible: true,  order: 15, width: 70  },
  ];

  get availableColumns(): ColumnDefinition[] {
    return this.columnsDefinition;
  }

  get orderedColumnsDefinition(): ColumnDefinition[] {
    return this.columnsDefinition
      .filter(c => c.visible)
      .sort((a, b) => a.order - b.order);
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private menuService: MenuService,
    private authService: AuthService,
    private studyReportService: StudyReportService,
    private admissionService: AdmissionService,
    private pdfService: PdfService,
    private studyReportWizardFactory: StudyReportWizardFactory,
    private notificationToastService: NotificationToastService,
    private confirmDialogService: ConfirmDialogService,
    private studyReportWizardService: StudyReportWizardService,
    private studyReportUnificationDialogService: StudyReportUnificationDialogService,
    private datePipe: DatePipe
  ) {
    this.menuService.setMenuTitle("Informe", "Control");
  }

  ngOnInit(): void {
    this.canPublishForced = this.authService.canPublishForced();
    this.restoreColumns();
    this.restoreSort();
    this.restoreColumnWidths();
  }

  ngOnDestroy() {
    this.removeResizeListeners();
  }

  // ── Column visibility ───────────────────────────────────────────────────

  isColumnVisible(field: string): boolean {
    const col = this.columnsDefinition.find(c => c.field === field);
    return col ? col.visible : false;
  }

  setColumnVisibility(field: string, visible: boolean) {
    const col = this.columnsDefinition.find(c => c.field === field);
    if (col) { col.visible = visible; this.saveColumns(); this.refreshGrid(); }
  }

  showAllColumns() {
    this.columnsDefinition.forEach(c => (c.visible = true));
    this.saveColumns();
    this.refreshGrid();
  }

  private saveColumns() {
    const state = this.columnsDefinition.map(c => ({ field: c.field, visible: c.visible, order: c.order }));
    sessionStorage.setItem(this.sessionColumnsKey, JSON.stringify(state));
  }

  private restoreColumns() {
    const raw = sessionStorage.getItem(this.sessionColumnsKey);
    if (!raw) { return; }
    try {
      const state: { field: string; visible: boolean; order: number }[] = JSON.parse(raw);
      state.forEach(s => {
        const col = this.columnsDefinition.find(c => c.field === s.field);
        if (col) { col.visible = s.visible; col.order = s.order; }
      });
    } catch { }
  }

  // ── Sort ────────────────────────────────────────────────────────────────

  sortByColumn(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortField = field;
      this.sortDirection = "asc";
    }
    this.saveSort();
    this.refreshGrid();
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) { return "unfold_more"; }
    return this.sortDirection === "asc" ? "arrow_upward" : "arrow_downward";
  }

  private sortAllData(items: StudyReportSearchItem[]): StudyReportSearchItem[] {
    if (!this.sortField) { return items; }
    const dir = this.sortDirection === "asc" ? 1 : -1;
    return [...items].sort((a, b) => {
      const va = this.getColumnFilterValue(a, this.sortField);
      const vb = this.getColumnFilterValue(b, this.sortField);
      return va < vb ? -dir : va > vb ? dir : 0;
    });
  }

  private saveSort() {
    sessionStorage.setItem(this.sessionSortKey, JSON.stringify({ field: this.sortField, direction: this.sortDirection }));
  }

  private restoreSort() {
    const raw = sessionStorage.getItem(this.sessionSortKey);
    if (!raw) { return; }
    try {
      const s = JSON.parse(raw);
      this.sortField = s.field;
      this.sortDirection = s.direction;
    } catch { }
  }

  // ── Column filters ───────────────────────────────────────────────────────

  onColumnFilterInput(field: string, value: string) {
    this.columnFilters[field] = value;
    this.refreshGrid();
  }

  private applyColumnFilters(items: StudyReportSearchItem[]): StudyReportSearchItem[] {
    return items.filter(item => {
      return Object.keys(this.columnFilters).every(field => {
        const filterVal = this.normalizeFilterValue(this.columnFilters[field]);
        if (!filterVal) { return true; }
        const cellVal = this.normalizeFilterValue(this.getColumnFilterValue(item, field));
        return cellVal.includes(filterVal);
      });
    });
  }

  private getColumnFilterValue(item: StudyReportSearchItem, field: string): string {
    switch (field) {
      case "reservationHour":         return this.datePipe.transform(item.DateTime, "dd/MM/yyyy HH:mm") || "";
      case "deliveryHour":            return this.datePipe.transform(item.DeliveryDate, "dd/MM/yyyy HH:mm") || "";
      case "protocol":                return item.Protocol || "";
      case "patientFullName":         return item.PatientFullName || "";
      case "practiceName":            return item.PracticeName || "";
      case "serviceName":             return item.ServiceName || "";
      case "entityName":              return item.EntityName || "";
      case "state":                   return item.State || "";
      case "studyReportRegion":       return item.StudyReportRegion || "";
      case "cantidad":                return item.NumberOfPractices !== null && item.NumberOfPractices !== undefined ? item.NumberOfPractices.toString() : "";
      case "adminControled":          return item.AdminControled || "";
      case "studyReportPhysician":    return item.StudyReportPhysician || "";
      case "statusPhotographyName":   return item.StatusPhotographyName || "";
      case "published":               return item.PublishedYesNo || "";
      case "lastLogisticscommentary": return item.LastLogisticscommentary || "";
      case "visualizationCode":       return item.VisualizationCode || "";
      default:                        return "";
    }
  }

  private normalizeFilterValue(value: string): string {
    if (!value) { return ""; }
    return value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  // ── Refresh ──────────────────────────────────────────────────────────────

  private refreshGrid() {
    const filtered = this.applyColumnFilters(this.allItems);
    const sorted = this.sortAllData(filtered);
    this.pager.setItems(sorted);
  }

  // ── Column resize ────────────────────────────────────────────────────────

  getColumnWidth(field: string): number {
    const col = this.columnsDefinition.find(c => c.field === field);
    return col ? col.width : 150;
  }

  startResize(event: MouseEvent, field: string) {
    event.preventDefault();
    event.stopPropagation();
    const startX = event.clientX;
    const col = this.columnsDefinition.find(c => c.field === field);
    const startWidth = col ? col.width : 150;
    this.removeResizeListeners();
    const moveHandler: EventListener = (e: MouseEvent) => {
      const newWidth = Math.max(50, startWidth + (e.clientX - startX));
      if (col) { col.width = newWidth; }
    };
    const upHandler: EventListener = () => {
      this.removeResizeListeners();
      this.saveColumnWidths();
    };
    document.addEventListener("mousemove", moveHandler);
    document.addEventListener("mouseup", upHandler);
    this.resizeListeners = { move: moveHandler, up: upHandler };
  }

  private removeResizeListeners() {
    if (this.resizeListeners) {
      document.removeEventListener("mousemove", this.resizeListeners.move);
      document.removeEventListener("mouseup", this.resizeListeners.up);
      this.resizeListeners = null;
    }
  }

  private saveColumnWidths() {
    const widths: { [field: string]: number } = {};
    this.columnsDefinition.forEach(c => (widths[c.field] = c.width));
    sessionStorage.setItem(this.sessionColumnWidthsKey, JSON.stringify(widths));
  }

  private restoreColumnWidths() {
    const raw = sessionStorage.getItem(this.sessionColumnWidthsKey);
    if (!raw) { return; }
    try {
      const widths: { [field: string]: number } = JSON.parse(raw);
      this.columnsDefinition.forEach(c => {
        if (widths[c.field] !== undefined) { c.width = widths[c.field]; }
      });
    } catch { }
  }

  // ── Column drag/drop ─────────────────────────────────────────────────────

  onHeaderDragStart(event: DragEvent, field: string) {
    this.dragSourceField = field;
    event.dataTransfer.effectAllowed = "move";
  }

  onHeaderDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  onHeaderDrop(event: DragEvent, targetField: string) {
    event.preventDefault();
    if (!this.dragSourceField || this.dragSourceField === targetField) { return; }
    const visible = this.orderedColumnsDefinition;
    const fromIdx = visible.findIndex(c => c.field === this.dragSourceField);
    const toIdx = visible.findIndex(c => c.field === targetField);
    if (fromIdx < 0 || toIdx < 0) { return; }
    moveItemInArray(visible, fromIdx, toIdx);
    visible.forEach((c, i) => {
      const col = this.columnsDefinition.find(x => x.field === c.field);
      if (col) { col.order = i; }
    });
    this.saveColumns();
    this.dragSourceField = null;
  }

  onHeaderDragEnd() {
    this.dragSourceField = null;
  }

  get selectedAmount(): number {
    if (this.selection.selected) {
      return this.selection.selected.length;
    } else {
      return 0;
    }
  }

  isAllSelected() {
    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.pager.getAllItems().forEach((row) => this.selection.select(row));
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = [...pagedItems];
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<StudyReportSearchItem>) {
    this.allItems = response.items || [];
    this.studyReportSearchItem = this.allItems;
    this.searchFilters = response.searchFilters;
    this.selection = new SelectionModel<StudyReportSearchItem>(true, []);
    this.refreshGrid();
  }

  onStartSearch() {
    this.loading = true;
  }

  async viewMergedStudyReport(studyReportSearchItem: StudyReportSearchItem) {
    try {
      const studyReportViewerDialogRequest =
        new StudyReportViewerDialogRequest();
      const contorlAdmin = this.authService.controlAdminReport();
      studyReportViewerDialogRequest.CanConfirm = false;
      studyReportViewerDialogRequest.CanControl = contorlAdmin;
      studyReportViewerDialogRequest.CanFix = contorlAdmin;

      const report = await this.studyReportService.getStudyReportPdf(
        studyReportSearchItem.StudyReportId,
        true
      );

      if (report && report.ReportBase64) {
        const pdfUrl = this.pdfService.base64ToPdfUrl(report.ReportBase64);
        studyReportViewerDialogRequest.SafeResourceUrl =
          this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);

        const dialogRef = this.dialog.open(StudyReportViewerDialogComponent, {
          width: "90%",
          height: "600px",
          data: studyReportViewerDialogRequest,
        });

        dialogRef
          .afterClosed()
          .subscribe(async (result: StudyReportViewerDialogResponse) => {
            if (result && result.ControlAdmin) {
              this.controlAdmin(studyReportSearchItem);
            } else if (result && result.Fix) {
              this.studyReportReverse(studyReportSearchItem);
            }
          });
      } else {
        this.notificationToastService.error(
          "No existe informe confirmado para visualizar",
          "Informes"
        );
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loading = false;
    }
  }

  async massivePrintDos() {
    try {
      let studyReports = this.selection.selected;
      if (studyReports.length > 0) {
        this.loadingMasiveAction = true;
        let studyReports = this.selection.selected;
        let report = await this.studyReportService.getMergedStudiesReportPdf(
          studyReports.map((s) => s.StudyReportId),
          false
        );
        this.pdfService.base64ToPdfPrint(report.ReportBase64);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async massivePrint() {
    try {
      this.loadingMasiveAction = true;
      const studyReportViewerDialogRequest =
        new StudyReportViewerDialogRequest();
      studyReportViewerDialogRequest.CanConfirm = false;

      const chunk = 10;
      let studyReportIds = this.selection.selected.map((s) => s.StudyReportId);

      const reports = await this.studyReportService.getStudiesReportPdf(
        studyReportIds,
        false
      );

      if (reports && reports.length > 0) {
        for (let index = 0; index < reports.length; index += chunk) {
          const temparray = reports.slice(index, index + chunk);
          for (let i = 0; i < temparray.length; i++) {
            const element = temparray[i];
            if (element.ReportBase64) {
              this.pdfService.base64ToPdfPrint(element.ReportBase64);
            }
          }
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  // <div>{{element.VisualizationCode}}</div>

  async copyLink(link: string) {
    try {
      this.copyClipboardText(link);
      this.notificationToastService.success(
        "Se copió el link del informe al portapapeles",
        "Link visualizacion"
      );
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    }
  }

  copyClipboardText(text: string) {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData("text/plain", text);
      e.preventDefault();
    };

    document.addEventListener("copy", listener);
    document.execCommand("copy");
    document.removeEventListener("copy", listener);
  }

  async reportPhysicianReplacement() {
    try {
      this.loadingMasiveAction = true;
      let studyReports = this.selection.selected;
      if (studyReports.length > 0) {
        this.dialog
          .open(ReportPhysicianReplacementDialogComponent, {
            width: "50%",
            data: { studyReports: studyReports },
          })
          .afterClosed()
          .subscribe((result) => {
            if (result) {
              studyReports.forEach((element) => {
                element.StudyReportPhysician = result.Name;
              });
            }
          });
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async reportPhysicianClear() {
    try {
      this.loadingMasiveAction = true;
      let studyReports = this.selection.selected;
      if (studyReports.length > 0) {
        let response = await this.studyReportService.clearReportPhysician(
          studyReports.map((s) => s.StudyReportId)
        );
        if (response.BlockIds.length === 0) {
          studyReports.forEach((s) => (s.StudyReportPhysician = null));
          this.notificationToastService.success(
            "Se ha eliminado el médico correctamente",
            "Reemplazo de médico"
          );
        } else {
          this.notificationToastService.error(
            "Existen informes bloqueados",
            "Reemplazo de médico"
          );
          this.notificationToastService.info(
            studyReports
              .filter((s) => response.BlockIds.indexOf(s.StudyReportId) > -1)
              .map((s) => s.Protocol)
              .join("<br>"),
            "Protocolos bloqueados",
            true,
            true,
            true
          );
        }
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Reemplazo de médico"
      );
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async printOrders() {
    try {
      let studyReports = this.selection.selected;
      if (studyReports.length > 0) {
        this.loadingMasiveAction = true;
        let studyReports = this.selection.selected;
        let report = await this.admissionService.getOrderReportsMerged(
          studyReports.map((s) => s.MedicalApponitmentId)
        );
        this.pdfService.base64ToPdfPrint(report.ReportBase64);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async publishWeb() {
    try {
      this.loadingMasiveAction = true;
      let studyReports = this.selection.selected;
      await this.studyReportService.publishWeb(studyReports);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async noPublishWeb() {
    try {
      this.loadingMasiveAction = true;
      let studyReports = this.selection.selected;
      await this.studyReportService.noPublishWeb(studyReports);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  async publishWebForced(item: StudyReportSearchItem) {
    try {
      item.Loading = true;
      await this.studyReportService.publishWebForced([item]);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      item.Loading = false;
    }
  }

  async noPublishWebForced(item: StudyReportSearchItem) {
    try {
      item.Loading = true;
      await this.studyReportService.noPublishWebForced([item]);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      item.Loading = false;
    }
  }

  async sendMassiveMails() {
    try {
      this.loadingMasiveAction = true;

      let studyReports = this.selection.selected;

      await this.studyReportService.sendMassiveMails(studyReports);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      this.loadingMasiveAction = false;
    }
  }

  openAdmisionLogViewDialog(
    studyReportSearchItem: StudyReportSearchItem
  ): void {
    this.dialog.open(LogViewDialogComponent, {
      width: "50%",
      data: studyReportSearchItem.MedicalApponitmentId,
    });
  }

  openLogisticsCommnetEdit(studyReportSearchItem: StudyReportSearchItem) {
    this.dialog.open(StudyReportLogisticsCommentDialogComponent, {
      width: "50%",
      data: { studyReportId: studyReportSearchItem.StudyReportId },
    });
  }

  async openStatusPhotographyEdit(
    studyReportSearchItem: StudyReportSearchItem
  ) {
    var response = await this.dialog
      .open(StatusPhotographyDialogComponent, {
        width: "50%",
        data: {
          medicalAppointmentId: studyReportSearchItem.MedicalApponitmentId,
          statusPhotographyName: studyReportSearchItem.StatusPhotographyName,
        },
      })
      .afterClosed()
      .toPromise();

    if (response) {
      studyReportSearchItem.StatusPhotographyName = response.Name;
    }
  }

  async controlAdmin(studyReportSearchItem: StudyReportSearchItem) {
    try {
      studyReportSearchItem.Loading = true;
      await this.studyReportService.adminControled([studyReportSearchItem]);
      studyReportSearchItem.AdminControled = "Sí";
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Controlar admin."
      );
    } finally {
      studyReportSearchItem.Loading = false;
    }
  }

  studyReportReverse(studyReportSearchItem: StudyReportSearchItem): void {
    if (
      studyReportSearchItem.IsInDelivery &&
      <StudyReportStateEnum>studyReportSearchItem.StateId !==
        StudyReportStateEnum.Pending
    ) {
      this.notificationToastService.error(
        "No es posible revertir el informe",
        "Informe"
      );
    } else {
      const dialogRef = this.dialog.open(
        StudyReportReverserReasonDialogComponent,
        {
          width: "50%",
          data: studyReportSearchItem.StudyReportId,
        }
      );

      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          this.studyReportEdit(studyReportSearchItem);
        }
      });
    }
  }

  async studyReportEdit(studyReportSearchItem: StudyReportSearchItem) {
    try {
      studyReportSearchItem.Loading = true;
      await this.StudyReportLockAndStartWizard(studyReportSearchItem);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      studyReportSearchItem.Loading = false;
    }
  }

  private async StudyReportLockAndStartWizard(
    studyReportSearchItem: StudyReportSearchItem
  ) {
    const lockInfo = await this.studyReportService.studyReportLock(
      studyReportSearchItem.StudyReportId,
      studyReportSearchItem.PracticeRegionId,
      +this.authService.getStudyReportCircuitId(),
      this.authService.getUserId()
    );
    if (!lockInfo.IsLock) {
      this.StudyReportWizardServiceInitialize(studyReportSearchItem);
    } else if (lockInfo.AutoLock) {
      this.confirmDialogService
        .confirm(
          "Informe bloqueado",
          "El informe está siendo editado actualmente por usted en esta u otra computadora. Desea continuar?",
          "Sí",
          "No"
        )
        .subscribe(async (value) => {
          if (value) {
            await this.studyReportService.studyReportUnlock(
              studyReportSearchItem.StudyReportId
            );
            this.studyReportEdit(studyReportSearchItem);
          }
        });
    } else {
      this.notificationToastService.error(
        "El informe se encuentra bloqueado por el usuario " + lockInfo.UserLock,
        "Informe bloqueado"
      );
    }
  }

  private async StudyReportWizardServiceInitialize(
    studyReportSearchItem: StudyReportSearchItem
  ) {
    // TODO: aca validar unificacion
    const info =
      await this.studyReportUnificationDialogService.startUnificationDialogIfRequired(
        studyReportSearchItem
      );
    if (info) {
      this.wizardServiceInitializeAndNavigate(info);
    }
  }

  private wizardServiceInitializeAndNavigate(
    studyReportSearchItem: StudyReportSearchItem
  ) {
    this.studyReportWizardService.initialize(
      this.studyReportWizardFactory.CreateStudyReportWizard(
        studyReportSearchItem,
        false,
        this.authService.controlAdminReport()
      )
    );
    this.router.navigate(["/study-report-wizard"]);
  }

  goMedicalOrderScann(studyReportSearchItem: StudyReportSearchItem) {
    const dialogRef = this.dialog.open(MedicalOrderScannViewComponent, {
      width: "90%",
      height: "600px",
      data: { medicalorderId: studyReportSearchItem.MedicalOrderId },
    });
  }

  async studyReportUnlock(item: StudyReportSearchItem) {
    try {
      item.Loading = true;
      await this.studyReportService.studyReportsUnlock([item.StudyReportId]);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Informe");
    } finally {
      item.Loading = false;
    }
  }

  async studyReportsUnlock() {
    if (this.selection.selected && this.selection.selected.length > 0) {
      try {
        this.loadingMasiveAction = true;
        await this.studyReportService.studyReportsUnlock(
          this.selection.selected.map((item) => item.StudyReportId)
        );
      } catch (err) {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Informe"
        );
      } finally {
        this.loadingMasiveAction = false;
      }
    }
  }

  sendDeliverySector() {
    if (this.selection.selected && this.selection.selected.length > 0) {
      const dialogRef = this.dialog.open(
        StudyReportDeliverySectorDialogComponent,
        {
          width: "40%",
          height: "200px",
          data: this.selection.selected,
        }
      );
    }
  }
}
